import React from "react";
import Bal from "./BalCom";
import BalEntryToPrisoner from "./BalEntryToPrisoner";
import BalIncarceration from "./BalIncarceration";
import BalochistanPrisonStatistics from "./BalochistanPrisonStatistics";
import BalTimeline from "./BalTimeline";
import BalVoicenotes from "./BalVoicenotes";

function BalIndex() {
  return (
    <div>
      <div className="bg-bal-img">
        <div className="container">
          <Bal />
          <BalTimeline />
        </div>
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/bgcrop.png")}
            alt="bgcrop"
          />
        </div>
      </div>
      <div className="container">
        <BalVoicenotes />
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/voice2.png")}
            alt="voice2"
          />
        </div>
        <BalIncarceration />
        <BalochistanPrisonStatistics />
      </div>
      <BalEntryToPrisoner />
    </div>
  );
}

export default BalIndex;
